export { default } from './CollectionCategory';
